import React from "react";
import { Button, DialogActions, TextField } from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  medicineName: Yup.string()
    .required("Medicine Name is required")
    .max(100, "Max 100 characters"),
  dosage: Yup.string().max(50, "Max 50 characters"),
  frequency: Yup.string().max(50, "Max 50 characters"),
  instruction: Yup.string().max(200, "Max 200 characters"),
});

const AddMedicines = ({ onSubmit, onCancel }) => {
  return (
    <Formik
      initialValues={{
        medicineName: "",
        dosage: "",
        frequency: "",
        instruction: "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        onSubmit(values);
      }}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <Field
            as={TextField}
            name="medicineName"
            label="Medicine Name"
            fullWidth
            margin="normal"
            required
            error={touched.medicineName && !!errors.medicineName}
            helperText={touched.medicineName && errors.medicineName}
          />
          <Field
            as={TextField}
            name="dosage"
            label="Dosage"
            fullWidth
            margin="normal"
            error={touched.dosage && !!errors.dosage}
            helperText={touched.dosage && errors.dosage}
          />
          <Field
            as={TextField}
            name="frequency"
            label="Frequency"
            fullWidth
            margin="normal"
            error={touched.frequency && !!errors.frequency}
            helperText={touched.frequency && errors.frequency}
          />
          <Field
            as={TextField}
            name="instruction"
            label="Instruction"
            fullWidth
            margin="normal"
            rows={2}
            error={touched.instruction && !!errors.instruction}
            helperText={touched.instruction && errors.instruction}
          />

          <DialogActions>
            <Button onClick={onCancel} color="secondary">
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={isSubmitting}
            >
              Add
            </Button>
          </DialogActions>
        </Form>
      )}
    </Formik>
  );
};

export default AddMedicines;
